export enum BannerTextType {
  DANGER,
  INFO,
}
